var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"competences-wrapper"},[_c('h3',{staticClass:"title"},[_vm._v("Необходимо прокачать")]),_c('StyleTabs',{staticClass:"tabs",attrs:{"tabs":_vm.tabs,"activeTab":_vm.activeTab},on:{"change":_vm.setTab}}),_c('div',{staticClass:"tab"},[_c(_vm.tabs[_vm.activeTab].component,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }